(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5769],{

/***/ 59968:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/customizing/print/product",
      function () {
        return __webpack_require__(99381);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 43774:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19521);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  position: fixed;\n  top: 0;\n  left: 0;\n  background-color: rgba(0, 0, 0, 0.8);\n  z-index: 10000001;\n  width: 100vw;\n  height: 100vh;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  & strong {\n    color: #e74c3c;\n  }\n\n  .modal-section {\n    width: fit-content;\n    background-color: white;\n    overflow: auto;\n    border: none;\n    display: flex;\n    flex-direction: column;\n    padding: 30px;\n    border-radius: 10px;\n\n    & > i {\n      font-size: 2rem;\n      color: black;\n      cursor: pointer;\n      :hover {\n        color: #3bb77e;\n      }\n    }\n    @media (max-width: 767px) {\n      padding: 10px;\n    }\n    @media (max-width: 575px) {\n      padding: 10px;\n      width: 90vw;\n    }\n  }\n\n  .modal-content {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    padding: 1rem;\n    border: none;\n    margin: 0 auto;\n    & h5 {\n      font-size: 18px;\n      margin: 15px 0px;\n      & pre {\n        overflow: visible !important;\n        text-align: center;\n      }\n      @media (max-width: 575px) {\n        font-size: 1rem;\n      }\n    }\n    & img {\n      width: 75%;\n    }\n\n    & a {\n      margin-top: 20px;\n      width: 200px;\n    }\n\n    @media (max-width: 991px) {\n      & a {\n        width: 150px;\n      }\n    }\n    @media (max-width: 767px) {\n      & a {\n        width: 130px;\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var ModalWrapper = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-751e3b31-0"
})(_templateObject());
var InquiryCompleteModal = function(param) {
    var onClickInquiryComplete = param.onClickInquiryComplete, confirmText = param.confirmText, confirmImg = param.confirmImg;
    globalThis.onkeydown = function(e) {
        if (e.code === "Escape") return onClickInquiryComplete();
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ModalWrapper, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "modal-section",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "modal-content",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                            src: confirmImg || "/assets/imgs/page/common/inquiry_complete_icon.png"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
                            children: confirmText || "\uC18C\uC911\uD55C \uC815\uBCF4 \uAC10\uC0AC\uD569\uB2C8\uB2E4!"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            className: "btn",
                            onClick: onClickInquiryComplete,
                            children: "\uC644\uB8CC"
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (InquiryCompleteModal);


/***/ }),

/***/ 17461:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(64384);
/* harmony import */ var _api_products__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(81628);
/* harmony import */ var _common_auth__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(48106);
/* harmony import */ var _common_splicePrice__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(8025);
/* harmony import */ var _common_util_getDate__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(69644);
/* harmony import */ var _redux_action_baskets__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(83173);
/* harmony import */ var _redux_action_cart__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(68866);
/* harmony import */ var _Proucts_list_styles__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(30938);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}













var TableTypeList = function(param) {
    var productList = param.productList, searchList = param.searchList, basketsItems = param.basketsItems, cartItems = param.cartItems, basketsCount = param.basketsCount, dummyList = param.dummyList, _$addToCart = param.addToCart, _$insertBasketsAction = param.insertBasketsAction, purchaseDirect = param.purchaseDirect, addCart = param.addCart, inCart = param.inCart, viewFeature = param.viewFeature, products = param.products;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    var inBasket = function(product) {
        return inCart ? inCart(product) : (basketsItems === null || basketsItems === void 0 ? void 0 : basketsItems.find(function(basketsItem) {
            return basketsItem.pcode === product.pcode;
        })) || (cartItems === null || cartItems === void 0 ? void 0 : cartItems.find(function(cartItem) {
            return cartItem.pcode === product.pcode;
        }));
    };
    // 장바구니 담기
    var handleCart = function() {
        var _ref = _asyncToGenerator(_home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(product) {
            return _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (product) {
                            dataLayer.push({
                                ecommerce: null
                            }); // Clear the previous ecommerce object.
                            dataLayer.push({
                                event: "add_to_cart",
                                ecommerce: {
                                    items: [
                                        {
                                            item_name: product.pname,
                                            item_id: product.pcode,
                                            price: product.price,
                                            item_brand: product.supplier,
                                            item_category: product.category_code.length > 2 ? product.category_code : dummyList === null || dummyList === void 0 ? void 0 : dummyList.category[product.category_code]
                                        }, 
                                    ]
                                }
                            });
                            // 채널톡 장비구니 이벤트
                            window.ChannelIO("track", "AddToCart", {
                                pcode: product.pcode
                            });
                        }
                        if ((0,_common_auth__WEBPACK_IMPORTED_MODULE_7__/* .getCookie */ .ej)("token")) {
                            _ctx.next = 5;
                            break;
                        }
                        return _ctx.abrupt("return", _$addToCart(product));
                    case 5:
                        return _ctx.abrupt("return", _$insertBasketsAction(product, 1));
                    case 6:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleCart(product) {
            return _ref.apply(this, arguments);
        };
    }();
    var moveToDetail = function() {
        var _ref = _asyncToGenerator(_home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(product) {
            var body, res, DATE, todays, tempToday, url;
            return _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        body = {
                            modes: "ViewCount",
                            pcode: product.pcode
                        };
                        _ctx.next = 3;
                        return (0,_api_products__WEBPACK_IMPORTED_MODULE_6__/* .ViewCountProduct */ .Ir)(body);
                    case 3:
                        res = _ctx.sent;
                        DATE = (0,_common_util_getDate__WEBPACK_IMPORTED_MODULE_10__/* .getDate */ ._3)();
                        todays = JSON.parse(sessionStorage.getItem("".concat(DATE)) || "[]");
                        tempToday = todays.filter(function(el) {
                            return el === product.pcode;
                        });
                        if (!tempToday.length) {
                            _ctx.next = 9;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 9:
                        todays.push(product.pcode);
                        sessionStorage.setItem("".concat(DATE), JSON.stringify(todays));
                        url = "/products/".concat(product.ename, "/").concat(product.pcode, "/");
                        router.push(url);
                    case 13:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function moveToDetail(product) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Proucts_list_styles__WEBPACK_IMPORTED_MODULE_9__/* .TableTypeWrapper */ .ze, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_Proucts_list_styles__WEBPACK_IMPORTED_MODULE_9__/* .Table */ .iA, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("thead", {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("tr", {
                            className: "header",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("th", {
                                    className: "img",
                                    children: "\uC774\uBBF8\uC9C0"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("th", {
                                    className: "name",
                                    children: "\uD488\uBA85"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("th", {
                                    className: "sizes",
                                    children: "\uC0AC\uC774\uC988"
                                }),
                                (router.query.code === "01" || router.query.code === "02") && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("th", {
                                            className: "golgi",
                                            children: "\uACE8"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("th", {
                                            className: "strength",
                                            children: "\uC9C0\uC885"
                                        })
                                    ]
                                }),
                                (router.query.code === "05" || viewFeature) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("th", {
                                    className: "feature",
                                    children: "\uC8FC\uC6D0\uB8CC"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("th", {
                                    className: "onePrice",
                                    children: "\uB2E8\uAC00"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("th", {
                                    className: "quantity",
                                    children: "\uBB36\uC74C \uC218\uB7C9"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("th", {
                                    children: "\uD310\uB9E4\uAC00"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("th", {
                                    children: "\uAD6C\uB9E4"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("tbody", {
                        children: (searchList === null || searchList === void 0 ? void 0 : searchList.length) > 0 || (productList === null || productList === void 0 ? void 0 : productList.length) > 0 ? (router.query.search ? searchList : productList).map(function(product, i) {
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("td", {
                                        className: "img",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                                            href: "/products/".concat(product.ename, "/").concat(product.pcode, "/"),
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
                                                onClick: function() {
                                                    return moveToDetail(product);
                                                },
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("img", {
                                                    src: product.main_image,
                                                    alt: product.pname
                                                })
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("td", {
                                        className: "name",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                                            href: "/products/".concat(product.ename, "/").concat(product.pcode, "/"),
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
                                                onClick: function() {
                                                    return moveToDetail(product);
                                                },
                                                children: product.pname
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("td", {
                                        className: "sizes",
                                        children: product.horizontal == 0 && product.vertical == 0 && product.height == 0 ? "-" : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                            children: [
                                                product.horizontal != 0 ? "\uAC00\uB85C: " + product.horizontal : "",
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("br", {}),
                                                product.vertical != 0 ? "\uC138\uB85C: " + product.vertical : "",
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("br", {}),
                                                product.height != 0 ? "\uB192\uC774: " + product.height : ""
                                            ]
                                        })
                                    }),
                                    (router.query.code === "01" || router.query.code === "02") && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("td", {
                                                className: "golgi",
                                                children: product.golgi
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("td", {
                                                className: "strength",
                                                children: product.strength
                                            })
                                        ]
                                    }),
                                    (router.query.code === "05" || viewFeature) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("td", {
                                        className: "feature",
                                        children: product.feature ? product.feature : "-"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("td", {
                                        className: "onePrice",
                                        children: Number(product.quantity) < 1 ? "-" : (0,_common_splicePrice__WEBPACK_IMPORTED_MODULE_11__/* .priceComma */ .a)(Math.floor(Number(product.discount_price) / Number(product.quantity))) + "\uC6D0"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("td", {
                                        className: "quantity",
                                        children: product.quantity == 0 ? "-" : (0,_common_splicePrice__WEBPACK_IMPORTED_MODULE_11__/* .priceComma */ .a)(product.quantity) + "\uAC1C"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("td", {
                                        className: "price",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_Proucts_list_styles__WEBPACK_IMPORTED_MODULE_9__/* .PriceBox */ .bz, {
                                            children: [
                                                product.salePer > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                                        children: product.price && " ".concat((0,_common_splicePrice__WEBPACK_IMPORTED_MODULE_11__/* .priceComma */ .a)(product.price), "\uC6D0")
                                                    })
                                                }),
                                                (0,_common_splicePrice__WEBPACK_IMPORTED_MODULE_11__/* .priceComma */ .a)(product.discount_price),
                                                "\uC6D0"
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("td", {
                                        className: "btnWrapper",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Proucts_list_styles__WEBPACK_IMPORTED_MODULE_9__/* .BtnWrapper */ .Bo, {
                                            children: product.sold_out === "Y" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                                    children: "\uD488\uC808"
                                                })
                                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                                                children: [
                                                    purchaseDirect && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Proucts_list_styles__WEBPACK_IMPORTED_MODULE_9__/* .CheckoutBtn */ .$F, {
                                                        className: "btn-sm",
                                                        onClick: purchaseDirect(product),
                                                        children: "\uBC14\uB85C \uACB0\uC81C\uD558\uAE30"
                                                    }),
                                                    !inBasket(product) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Proucts_list_styles__WEBPACK_IMPORTED_MODULE_9__/* .CartBtn */ .Eo, {
                                                        className: "mobonCart btn-sm",
                                                        onClick: function() {
                                                            return addCart ? addCart(product) : handleCart(product);
                                                        },
                                                        children: "\uC7A5\uBC14\uAD6C\uB2C8 \uB2F4\uAE30"
                                                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Proucts_list_styles__WEBPACK_IMPORTED_MODULE_9__/* .CartBtn */ .Eo, {
                                                        className: "btn-sm",
                                                        onClick: function() {
                                                            return addCart ? addCart(product) : handleCart(product);
                                                        },
                                                        inCart: true,
                                                        children: "\uC7A5\uBC14\uAD6C\uB2C8 \uB2F4\uAE40"
                                                    })
                                                ]
                                            })
                                        })
                                    })
                                ]
                            }, i);
                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("tr", {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("td", {
                                colSpan: 999,
                                children: "\uC870\uAC74\uC5D0 \uB9DE\uB294 \uC0C1\uD488\uC774 \uC5C6\uC2B5\uB2C8\uB2E4."
                            })
                        })
                    })
                ]
            })
        })
    });
};
var mapStateToProps = function(state) {
    return {
        products: state.products,
        cartItems: state.cart,
        basketsItems: state.baskets.items,
        basketsCount: state.baskets.count
    };
};
var mapDispatchToProps = {
    addToCart: _redux_action_cart__WEBPACK_IMPORTED_MODULE_12__/* .addToCart */ .Xq,
    insertBasketsAction: _redux_action_baskets__WEBPACK_IMPORTED_MODULE_8__/* .insertBasketsAction */ .el
};
/* harmony default export */ __webpack_exports__["Z"] = ((0,react_redux__WEBPACK_IMPORTED_MODULE_5__/* .connect */ .$j)(mapStateToProps, mapDispatchToProps)(TableTypeList));


/***/ }),

/***/ 99381:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ product; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./utils/seo/SeoMeta.js
var SeoMeta = __webpack_require__(44027);
// EXTERNAL MODULE: ./components/customizing/print/printTab/PrintTab.jsx
var PrintTab = __webpack_require__(48071);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/customizing/print/Print.styles.js
var Print_styles = __webpack_require__(32252);
// EXTERNAL MODULE: ./components/customizing/print/printCart/PrintCart.js + 1 modules
var PrintCart = __webpack_require__(34077);
// EXTERNAL MODULE: ./components/customizing/print/PrintDesignService.js
var PrintDesignService = __webpack_require__(52658);
// EXTERNAL MODULE: ./hook/app/useUserInfo.js
var useUserInfo = __webpack_require__(15259);
// EXTERNAL MODULE: ./components/layout/Layout.js + 38 modules
var Layout = __webpack_require__(32511);
// EXTERNAL MODULE: ./components/filterList/FilterList.js + 3 modules
var FilterList = __webpack_require__(85830);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
;// CONCATENATED MODULE: ./components/customizing/print/PrintInquiryModal.js
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        '\n  position: fixed;\n  top: 0;\n  left: 0;\n  background-color: rgba(0, 0, 0, 0.8);\n  z-index: 10000001;\n  width: 100vw;\n  height: 100vh;\n\n  & strong {\n    color: #e74c3c;\n  }\n\n  .modal-section {\n    position: fixed;\n    top: 10vh;\n    left: 25vw;\n    width: 50vw;\n    max-height: 80vh;\n    background-color: white;\n    overflow: auto;\n    border: none;\n    display: flex;\n    flex-direction: column;\n    @media screen and (max-width: 991px) {\n      top: 10vh;\n      left: 15vw;\n      width: 70vw;\n      max-height: 80vh;\n    }\n    @media screen and (max-width: 767px) {\n      left: 10vw;\n      width: 80vw;\n    }\n  }\n\n  .header {\n    display: flex;\n    padding: 10px 10px;\n    & img {\n      margin-left: auto;\n      width: 35px;\n      cursor: pointer;\n    }\n  }\n  .title {\n    display: flex;\n    justify-content: center;\n    margin-bottom: 30px;\n    & h4 {\n      color: #3bb77e;\n    }\n  }\n\n  .modal-content {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    border: none;\n    margin: 0 auto;\n    overflow-y: auto;\n    padding: 0px 36px 36px 36px !important;\n    & > span {\n      color: black;\n    }\n  }\n\n  .inputWrapper {\n    width: 100%;\n    margin-bottom: 20px;\n    & h6 {\n      margin-bottom: 10px;\n      ::after {\n        content: "*";\n        margin-left: 2px;\n      }\n    }\n    & input {\n      height: 38px;\n      margin-bottom: 10px;\n      ::placeholder {\n        font-size: 14px;\n        color: #6c757da5;\n      }\n      :focus {\n        border-color: #3bb77e !important;\n        box-shadow: 0 0 0 0.25rem rgba(59, 183, 126, 0.25) !important;\n      }\n    }\n    .col {\n      display: flex;\n      flex-direction: column;\n      width: 50%;\n      & input {\n        width: 100%;\n        padding-right: 0;\n      }\n    }\n    @media screen and (max-width: 575px) {\n      .row {\n        display: flex;\n        flex-direction: column;\n        .col {\n          width: 100%;\n        }\n      }\n    }\n  }\n\n  & textarea {\n    min-height: 150px;\n    ::placeholder {\n      font-size: 14px;\n      color: #6c757da5;\n    }\n    :focus {\n      border-color: #3bb77e !important;\n      box-shadow: 0 0 0 0.25rem rgba(59, 183, 126, 0.25) !important;\n    }\n  }\n  .btnWrapper {\n    width: 100%;\n    & button {\n      width: 100%;\n    }\n  }\n\n  .checkboxWrapper {\n    display: grid;\n    grid-template-columns: repeat(4, 1fr);\n    grid-column-gap: 10px;\n    margin-bottom: 20px;\n    @media screen and (max-width: 767px) {\n      grid-template-columns: repeat(2, 1fr);\n    }\n  }\n  .designCheck {\n    margin-bottom: 30px;\n    display: flex;\n    flex-wrap: wrap;\n  }\n'
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  margin-right: ",
        ";\n  word-break: keep-all;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  width: ",
        ";\n  font-size: 1rem;\n  padding: ",
        ";\n  overflow: hidden;\n  border: 2px solid #ececec;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  background-color: ",
        ";\n  color: #4e4e4e;\n  border-color: ",
        ";\n  border-radius: 10px;\n  position: relative;\n  cursor: pointer;\n\n  & img {\n    margin: 0 auto;\n  }\n\n  .label_title {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    color: #4e4e4e;\n    font-size: 14px;\n    text-align: center;\n\n    & i {\n      padding-top: 1px;\n      :hover {\n        color: #3bb77e;\n      }\n    }\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  column-gap: 20px;\n  row-gap: 10px;\n  & input {\n    padding: 6px 5px;\n  }\n  @media screen and (max-width: 1200px) {\n    grid-template-columns: repeat(1, 1fr);\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}




var ModalWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-699a6ec4-0"
})(_templateObject());
var CheckBox = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-699a6ec4-1"
})(_templateObject1(), function(props) {
    return props.design ? "5px" : "0";
});
var CheckBoxLabel = styled_components_browser_esm/* default.label.withConfig */.ZP.label.withConfig({
    componentId: "sc-699a6ec4-2"
})(_templateObject2(), function(props) {
    return props.design ? "fit-content" : "100%";
}, function(props) {
    return props.design ? "10px 20px" : "10px 10px";
}, function(props) {
    return props.checked ? "#d6f2e5" : "#fff";
}, function(props) {
    return props.checked ? "#3bb77e" : "#ececec";
});
var FileWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-699a6ec4-3"
})(_templateObject3());
var PrintInquiryModal = function(param) {
    var onClickInquiry = param.onClickInquiry, submitInquiry = param.submitInquiry, onChangeInquiry = param.onChangeInquiry, inquiryInputs = param.inquiryInputs;
    globalThis.onkeydown = function(e) {
        if (e.code === "Escape") return onClickInquiry();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalWrapper, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "modal-section",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "header",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: "/assets/imgs/page/common/modal_close_icon.png",
                            alt: "modal_close_icon",
                            onClick: onClickInquiry
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "title",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                            children: "\uC815\uBCF4\uB97C \uC785\uB825\uD574\uC8FC\uC138\uC694"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "modal-content",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "inputWrapper",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "row",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "col",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                                        children: "\uBB38\uC758\uC790(\uC5C5\uCCB4) \uBA85"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                        type: "text",
                                                        onChange: function(e) {
                                                            return onChangeInquiry(e, "name");
                                                        }
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "col",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                                        children: "\uBB38\uC758\uC790 \uC5F0\uB77D\uCC98"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                        type: "text",
                                                        onChange: function(e) {
                                                            return onChangeInquiry(e, "tel");
                                                        }
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "row",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "col",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                                        children: "\uC774\uBA54\uC77C"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                        type: "text",
                                                        onChange: function(e) {
                                                            return onChangeInquiry(e, "email");
                                                        }
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "col",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                                        children: "\uC218\uB7C9"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                        type: "text",
                                                        onChange: function(e) {
                                                            return onChangeInquiry(e, "cnt");
                                                        }
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "row",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "col",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                                    children: "\uC778\uC1C4\uB97C \uC6D0\uD558\uB294 \uC0C1\uD488"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                    type: "text",
                                                    onChange: function(e) {
                                                        return onChangeInquiry(e, "usages");
                                                    },
                                                    placeholder: "ex) EL606 \uD0DD\uBC30\uBD09\uD22C (\uC18C)"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "row mb-20",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "col",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                                    children: "\uBB38\uC758 \uB0B4\uC6A9"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("textarea", {
                                                    type: "text",
                                                    onChange: function(e) {
                                                        return onChangeInquiry(e, "content");
                                                    },
                                                    placeholder: "ex) \uC5B8\uC81C\uAE4C\uC9C0 \uD544\uC694\uD558\uC2E0\uAC00\uC694, \uC5B4\uB5A4 \uB514\uC790\uC778\uC11C\uBE44\uC2A4\uAC00 \uD544\uC694\uD558\uC2E0\uAC00\uC694, \uCD94\uAC00\uC801\uC778 \uBB38\uC758\uC0AC\uD56D\uC744 \uB0A8\uACA8\uC8FC\uC138\uC694"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "row mb-20",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "col",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "h6 text-dark",
                                                    children: "\uCCA8\uBD80 \uD30C\uC77C"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(FileWrapper, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                            type: "file",
                                                            className: "form-control",
                                                            onChange: function(e) {
                                                                return onChangeInquiry(e, "file1");
                                                            }
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                            type: "file",
                                                            className: "form-control",
                                                            onChange: function(e) {
                                                                return onChangeInquiry(e, "file2");
                                                            }
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                            type: "file",
                                                            className: "form-control",
                                                            onChange: function(e) {
                                                                return onChangeInquiry(e, "file3");
                                                            }
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "row mb-20",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "col",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "h6 text-dark",
                                                    children: "\uC720\uC758 \uC0AC\uD56D"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                                    className: "border rounded p-3",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: "1. \uBAA8\uB2C8\uD130\uC758 \uC0C9\uC0C1\uACFC \uCD5C\uC885 \uC778\uC1C4\uBB3C\uC758 \uC0C9\uC0C1\uC740 \uCC28\uC774\uAC00 \uC788\uC744 \uC218 \uC788\uC2B5\uB2C8\uB2E4."
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: "2. \uACE0\uC18D \uC778\uC1C4\uC640 \uC7AC\uB2E8 \uACFC\uC815\uC744 \uAC70\uCE58\uBBC0\uB85C \uC778\uC1C4 \uC704\uCE58 \uBC0F \uC0AC\uC774\uC988\uC758 \uC624\uCC28\uAC00 \uBC1C\uC0DD \uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4."
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: "3. \uC5F4\uD48D\uC5D0 \uC758\uD55C \uAC74\uC870 \uBC29\uC2DD\uC73C\uB85C \uC789\uD06C\uAC00 \uC99D\uBC1C\uD558\uC5EC \uAE30\uD3EC\uAC00 \uC0DD\uAE30\uAC70\uB098 \uC0C9\uC0C1\uC774 \uBE60\uC9C0\uB294 \uACBD\uC6B0\uAC00 \uBC1C\uC0DD\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4."
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: "4. \uC778\uC1C4 \uBA74\uC801\uC774 \uB113\uC744 \uC2DC \uBE44\uC6A9\uC774 \uCD94\uAC00 \uB420 \uC218 \uC788\uC2B5\uB2C8\uB2E4. \uB610\uD55C \uC0C9\uC0C1 \uD45C\uD604\uC774 \uACE0\uB974\uC9C0 \uC54A\uAC70\uB098 \uBB3C\uACB0 \uBB34\uB2AC\uAC00 \uC0DD\uAE38 \uC218 \uC788\uC2B5\uB2C8\uB2E4."
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: "5. \uC704 \uC0AC\uC720\uB85C \uC778\uD55C \uC7AC\uC791\uC5C5\uC774\uB098 \uBC18\uD488\uC740 \uBD88\uAC00\uD569\uB2C8\uB2E4."
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: "6. \uC778\uC1C4 \uAD00\uB828\uB41C \uBB38\uC758\uB294 \uCE7C\uB81B\uC2A4\uD1A0\uC5B4 \uCC44\uB110\uD1A1\uC73C\uB85C \uC5B8\uC81C\uB4E0\uC9C0 \uB0A8\uACA8\uC8FC\uC138\uC694."
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "d-flex flex-row justify-content-start align-items-center",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "custome-checkbox",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                                type: "checkbox",
                                                                id: "checkBox1",
                                                                className: "form-check-input",
                                                                onChange: function(e) {
                                                                    return onChangeInquiry(e, "policy");
                                                                }
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                                className: "form-check-label",
                                                                htmlFor: "checkBox1",
                                                                style: {
                                                                    textTransform: "capitalize",
                                                                    color: "#696969",
                                                                    fontSize: "16px"
                                                                },
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    children: "\uC720\uC758\uC0AC\uD56D\uC5D0 \uB3D9\uC758\uD569\uB2C8\uB2E4."
                                                                })
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "btnWrapper",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    className: "btn",
                                    onClick: submitInquiry,
                                    children: "\uBB38\uC758\uD558\uAE30"
                                })
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var print_PrintInquiryModal = (PrintInquiryModal);

// EXTERNAL MODULE: ./components/elements/inquiryCompleteModal.js
var inquiryCompleteModal = __webpack_require__(43774);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/modern/QueryClientProvider.js
var QueryClientProvider = __webpack_require__(30202);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/modern/useQuery.js + 7 modules
var useQuery = __webpack_require__(87633);
// EXTERNAL MODULE: ./common/queryKeys.js
var queryKeys = __webpack_require__(51586);
// EXTERNAL MODULE: ./api/smallPackaging.js
var smallPackaging = __webpack_require__(85134);
;// CONCATENATED MODULE: ./hook/customizing/print/usePrintProductListQuery.js
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}




var usePrintProductListQuery = function() {
    return (0,useQuery/* useQuery */.a)({
        queryKey: [
            queryKeys/* QUERY_KEYS.CUSTOMIZING.PRINT.PRODUCTS */.U.CUSTOMIZING.PRINT.PRODUCTS
        ],
        queryFn: _asyncToGenerator(runtime_default().mark(function _callee() {
            var ref, body, res, ref1;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        body = {
                            modes: "ProductsListSet"
                        };
                        _ctx.next = 4;
                        return (0,smallPackaging/* smallPackagingAPI */.t)(body);
                    case 4:
                        res = _ctx.sent;
                        if (!(res.Code === "0000")) {
                            _ctx.next = 8;
                            break;
                        }
                        ;
                        return _ctx.abrupt("return", (ref1 = res.Data) === null || ref1 === void 0 ? void 0 : ref1.rows.data);
                    case 8:
                        throw new Error(((ref = res.Data) === null || ref === void 0 ? void 0 : ref.Msg) || "\uC0C1\uD488 \uBAA9\uB85D\uC744 \uBD88\uB7EC\uC624\uC9C0 \uBABB\uD588\uC2B5\uB2C8\uB2E4.");
                    case 9:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))
    });
};
var usePrintCartItemsQuery = function() {
    return (0,useQuery/* useQuery */.a)({
        queryKey: [
            queryKeys/* QUERY_KEYS.CUSTOMIZING.PRINT.CART */.U.CUSTOMIZING.PRINT.CART
        ],
        queryFn: function() {
            var items = JSON.parse(sessionStorage.getItem("printCart") || "[]");
            return items;
        },
        enabled: "object" !== "undefined"
    });
};

// EXTERNAL MODULE: ./common/alert.js
var common_alert = __webpack_require__(55150);
// EXTERNAL MODULE: ./api/products.js
var products = __webpack_require__(81628);
;// CONCATENATED MODULE: ./pages/customizing/print/product/index.js
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function product_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function product_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                product_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                product_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}



















var ProductPage = function() {
    var router = (0,next_router.useRouter)();
    var queryClient = (0,QueryClientProvider/* useQueryClient */.NL)();
    var listRef = (0,react.useRef)(null);
    var cartRef = (0,react.useRef)(null);
    var ref6 = (0,react.useState)({}), inquiryInputs = ref6[0], setInquiryInputs = ref6[1];
    var ref1 = (0,react.useState)(false), openInquiryModal = ref1[0], setOpenInquiryModal = ref1[1];
    var ref2 = (0,react.useState)(false), openInquiryComplete = ref2[0], setOpenInquiryComplete = ref2[1];
    var ref3 = (0,useUserInfo/* default */.Z)(), userInfo = ref3.userInfo, getUserInfo = ref3.getUserInfo;
    var ref4 = usePrintProductListQuery(), productList = ref4.data;
    var ref5 = usePrintCartItemsQuery(), tmp = ref5.data, printCartItems = tmp === void 0 ? [] : tmp;
    // 카트 담기
    var addPrintCart = function(product) {
        var ref;
        if (!(userInfo === null || userInfo === void 0 ? void 0 : (ref = userInfo.Member) === null || ref === void 0 ? void 0 : ref.ukey)) {
            (0,common_alert/* failAlert */.qh)("\uB85C\uADF8\uC778 \uD6C4 \uC774\uC6A9 \uAC00\uB2A5\uD569\uB2C8\uB2E4.");
            router.push("/login");
            return;
        }
        var currentCart = queryClient.getQueryData([
            queryKeys/* QUERY_KEYS.CUSTOMIZING.PRINT.CART */.U.CUSTOMIZING.PRINT.CART
        ]) || [];
        if (currentCart.find(function(el) {
            return el.pcode === product.pcode;
        })) {
            (0,common_alert/* failAlert */.qh)("\uC774\uBBF8 \uB2F4\uAE34 \uC0C1\uD488\uC785\uB2C8\uB2E4.");
            return;
        }
        var newCart = [
            _objectSpread({}, product, {
                cnt: 1
            })
        ].concat(_toConsumableArray(currentCart));
        // 장바구니 업데이트
        queryClient.setQueryData([
            queryKeys/* QUERY_KEYS.CUSTOMIZING.PRINT.CART */.U.CUSTOMIZING.PRINT.CART
        ], newCart);
        sessionStorage.setItem("printCart", JSON.stringify(newCart));
        (0,common_alert/* successAlert */.Cq)("\uC7A5\uBC14\uAD6C\uB2C8\uC5D0 \uB2F4\uACBC\uC2B5\uB2C8\uB2E4.");
    };
    // 카트 담긴 상태
    var inCart = function(product) {
        return printCartItems.some(function(el) {
            return el.pcode === product.pcode;
        });
    };
    var onClickInquiry = function() {
        var _ref = product_asyncToGenerator(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setOpenInquiryModal(function(prev) {
                            return !prev;
                        });
                        setInquiryInputs({});
                    case 2:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function onClickInquiry() {
            return _ref.apply(this, arguments);
        };
    }();
    var onChangeInquiry = function(e, id) {
        if (id.includes("file")) {
            setInquiryInputs(_objectSpread({}, inquiryInputs, _defineProperty({}, id, e.target.files[0])));
            return;
        }
        if (id === "policy") {
            setInquiryInputs(_objectSpread({}, inquiryInputs, _defineProperty({}, id, e.target.checked)));
            return;
        }
        setInquiryInputs(_objectSpread({}, inquiryInputs, _defineProperty({}, id, e.target.value)));
    };
    var onClickInquiryComplete = function() {
        setOpenInquiryComplete(function(prev) {
            return !prev;
        });
    };
    var submitInquiry = function() {
        var _ref = product_asyncToGenerator(runtime_default().mark(function _callee() {
            var body, res, ref;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!(!inquiryInputs.name || !inquiryInputs.tel || !inquiryInputs.cnt || !inquiryInputs.usages || !inquiryInputs.email || !inquiryInputs.content)) {
                            _ctx.next = 3;
                            break;
                        }
                        (0,common_alert/* failAlert */.qh)("\uD56D\uBAA9\uC744 \uC804\uBD80 \uC785\uB825\uD574\uC8FC\uC138\uC694.");
                        return _ctx.abrupt("return");
                    case 3:
                        if (inquiryInputs.policy) {
                            _ctx.next = 6;
                            break;
                        }
                        (0,common_alert/* failAlert */.qh)("\uC720\uC758\uC0AC\uD56D\uC5D0 \uB3D9\uC758\uD574\uC8FC\uC138\uC694.");
                        return _ctx.abrupt("return");
                    case 6:
                        if (inquiryInputs.tel.match(/^(0[2-8][0-5]?|01[01346-9])-?([1-9]{1}[0-9]{2,3})-?([0-9]{4})$/)) {
                            _ctx.next = 9;
                            break;
                        }
                        (0,common_alert/* failAlert */.qh)("\uC0AC\uC6A9\uAC00\uB2A5\uD55C \uC804\uD654\uBC88\uD638\uB97C \uC785\uB825\uD574\uC8FC\uC138\uC694.");
                        return _ctx.abrupt("return");
                    case 9:
                        isLoading();
                        body = _objectSpread({
                            modes: "InquirySet",
                            division: "F",
                            pcode: "P000001"
                        }, inquiryInputs);
                        _ctx.next = 13;
                        return (0,products/* inquirySet */.Bg)(body);
                    case 13:
                        res = _ctx.sent;
                        if (res.Code === "0000") {
                            ;
                            (0,common_alert/* successAlert */.Cq)(((ref = res.Data) === null || ref === void 0 ? void 0 : ref.Msg) || "\uBB38\uC758\uAC00 \uB4F1\uB85D\uB418\uC5C8\uC2B5\uB2C8\uB2E4.");
                            onClickInquiryComplete();
                            onClickInquiry();
                            setInquiryInputs({});
                            isLoaded();
                        } else {
                            (0,common_alert/* failAlert */.qh)("\uBB38\uC758 \uB4F1\uB85D\uC5D0 \uC2E4\uD328\uD588\uC2B5\uB2C8\uB2E4.");
                            isLoaded();
                        }
                    case 15:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function submitInquiry() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        getUserInfo();
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Layout/* default */.Z, {
                parent: "\uD648",
                sub: "\uC18C\uB7C9\uC778\uC1C4",
                subTitle: "\uC0C1\uD488",
                pageTitle: SeoMeta/* SeoMeta.smallPrintServiceProduct.title */.e.smallPrintServiceProduct.title,
                pageDesc: SeoMeta/* SeoMeta.smallPrintServiceProduct.description */.e.smallPrintServiceProduct.description,
                pageKeyword: SeoMeta/* SeoMeta.smallPrintServiceProduct.keywords */.e.smallPrintServiceProduct.keywords,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PrintTab/* PrintTab */.d, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "container",
                        ref: listRef,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Print_styles/* NormalTitle */.XG, {
                                children: [
                                    "\uC18C\uB7C9\uC778\uC1C4 ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                        children: "\uC0C1\uD488 \uC120\uD0DD"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterList/* default */.Z, {
                                productList: productList,
                                inCart: inCart,
                                addCart: addPrintCart
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PrintDesignService/* PrintDesignService */.$, {})
                ]
            }),
            openInquiryModal && /*#__PURE__*/ (0,jsx_runtime.jsx)(print_PrintInquiryModal, {
                onClickInquiry: onClickInquiry,
                inquiryInputs: inquiryInputs,
                onChangeInquiry: onChangeInquiry,
                submitInquiry: submitInquiry
            }),
            openInquiryComplete && /*#__PURE__*/ (0,jsx_runtime.jsx)(inquiryCompleteModal/* default */.Z, {
                onClickInquiryComplete: onClickInquiryComplete
            })
        ]
    });
};
/* harmony default export */ var product = (ProductPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3662,9199,4231,2511,4027,9007,4948,928,5830,9774,2888,179], function() { return __webpack_exec__(59968); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);